module.exports = __webpack_public_path__ + "img/w29.2235685d.svg";